module.exports = __webpack_public_path__ + "static/media/Mermaid.4ddc46fd.jpg";